module.exports = __webpack_public_path__ + "img/make.1913e18a.png";